import React, { useEffect } from 'react'
import Cookies from 'js-cookie';
import Sheet from '@mui/joy/Sheet';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';
import MailIcon from '@mui/icons-material/Mail'
import ToastMessage from '../../common/ToastMessage';
import ArrowRightAltOutlinedIcon from '@mui/icons-material/ArrowRightAltOutlined';
import { jwtDecode } from 'jwt-decode';
import { EndPoints } from '../../utils/apiEndpoints';
import { useRoleStore } from '../../store/useRoleStore';
import { useUserStore } from '../../store/useUserStore';
import { darkModeBackgroud } from '../../utils/constants';
import { useLanguageStore } from '../../store/useLanguageStore';
import { useDarkModeStore } from '../../store/useDarkModeStore';
import { useNavigate, useSearchParams } from "react-router-dom";
import { expiredCokkieInDay, StorageItems } from '../../utils/storageItems';
import { confirmEmail, refreshTokenApiCall } from '../../services/LoginService';
import { getClaim, ROLE_CLAIM, TokenPayload } from '../../domain/helpers/TokenPayload';

export const ConfirmEmail = () => {
    const navigate = useNavigate();
    const { darkMode } = useDarkModeStore();
    const { language } = useLanguageStore();
    const { setUser } = useUserStore();
    const { setRole } = useRoleStore();
    const [searchParams] = useSearchParams();

    const userId = searchParams.get("userId");
    const decodedToken = searchParams.get("token");

    let token = Cookies.get(StorageItems.TOKEN);
    const refreshToken = Cookies.get(StorageItems.REFRESHTOKEN);

    const encodedToken = encodeURIComponent(decodedToken || "");

    const fetchData = async (userId: string, encodedToken: string) => {
        try {
            const response = await confirmEmail(userId, encodedToken);
            ToastMessage.Success(response && response.data && response.data.message ? response.data.message : '');
        } catch (error) {
            if (error) console.error('Error');
        }
    }

    const fetchRefreshTokenApi = async () => {
        if (token && refreshToken) {
            const response = await refreshTokenApiCall(token, refreshToken);
            if (response) {
                Cookies.set(StorageItems.TOKEN, response.token, { expires: expiredCokkieInDay });
                Cookies.set(StorageItems.REFRESHTOKEN, response.refreshToken, { expires: expiredCokkieInDay });
                const decodedToken = jwtDecode(response.token);
                setRole(getClaim(decodedToken as TokenPayload, ROLE_CLAIM as keyof TokenPayload)?.toString() ?? "");
                setUser(decodedToken as TokenPayload);
            }
        }
    }

    useEffect(() => {
        if (userId && encodedToken) {
            (async () => {
                await fetchData(userId, encodedToken);
                // await new Promise(resolve => setTimeout(resolve, 1000));
                await fetchRefreshTokenApi();
                localStorage.setItem(StorageItems.FIRSTTIMELOGIN, 'true');
                navigate(EndPoints.ONBOARDING);
            })();
        }
    }, []);

    const handleClick = () => {
        localStorage.setItem(StorageItems.FIRSTTIMELOGIN, 'true');
        navigate(EndPoints.ONBOARDING);
    }

    const sheetCss = {
        py: 4,
        my: 15,
        gap: 0,
        px: '6%',
        mx: 'auto',
        width: '45%',
        display: 'flex',
        borderRadius: 'md',
        flexDirection: 'column',
        boxShadow: '8px 8px 30px rgba(0, 0, 0, 0.2)',
        background: darkMode ? darkModeBackgroud : 'white'
    };
    return (
        <div className='w-100 h-100'>
            <Sheet sx={sheetCss}>
                <div className='ms-5 me-5'>
                    <Typography
                        component="div"
                        className={`text-center fw-bold mt-2 mb-2 ${darkMode && 'text-white'}`}
                    >
                        <MailIcon
                            sx={{
                                width: 55,
                                height: 55,
                                padding: 1.2,
                                color: 'white',
                                marginBottom: 2,
                                borderRadius: '50%',
                                background: '#1e7cd9',
                                border: '5px solid #c0ddfa'
                            }}
                        />
                    </Typography>
                    <Typography
                        component="div"
                        className={`text-center fw-bold fs-3 mt-1 mb-2`}
                    >
                        {language['EmailVerificationSuccess1']}
                    </Typography>


                    <div className='w-100 gap-2 mt-5 mb-2 d-flex align-items-center justify-content-center '>
                        <Button
                            type='submit'
                            className="w-50 pt-3 pb-3"
                            onClick={handleClick}
                            sx={{
                                fontSize: '16px',
                                background: '#0B6BCB',
                                color: 'white',
                                minWidth: 250,
                                '&:hover': {
                                    background: '#57a9fa',
                                }
                            }}
                        >
                            {language['BackToHomepage']}<ArrowRightAltOutlinedIcon className="ms-1" />
                        </Button>
                    </div>
                </div>

            </Sheet>
        </div>
    );
}
export default ConfirmEmail;